import { Injectable, inject } from '@angular/core';
import { ConsoleCaptureCollector } from '../collectors/console-capture.collector';
import { ErrorCaptureCollector } from '../collectors/error-capture.collector';
import { BrowserMetadataService } from '../metadata/browser-metadata.service';
import { EnvironmentMetadataService } from '../metadata/environment-metadata.service';
import { NetworkCaptureCollector } from '../collectors/network-capture.collector';
import { ResourceTimingCollector } from '../collectors/resource-timing.collector';
import { RouteHistoryCollector } from '../collectors/route-history.collector';
import { SessionTimelineCollector } from '../collectors/session-timeline.collector';
import { UserMetadataService } from '../metadata/user-metadata.service';
import { TechnicalDiagnosticsPayload } from '../models/technical-diagnostics-payload';

@Injectable({
  providedIn: 'root',
})
export class TechnicalDiagnosticsOrchestratorService {
  private readonly consoleCapture = inject(ConsoleCaptureCollector);
  private readonly browserMetadata = inject(BrowserMetadataService);
  private readonly environmentMetadata = inject(EnvironmentMetadataService);
  private readonly networkCapture = inject(NetworkCaptureCollector);
  private readonly errorCapture = inject(ErrorCaptureCollector);
  private readonly resourceTimingCapture = inject(ResourceTimingCollector);
  private readonly routeHistory = inject(RouteHistoryCollector);
  private readonly sessionTimeline = inject(SessionTimelineCollector);
  private readonly userMetadata = inject(UserMetadataService);

  start(): void {
    this.consoleCapture.start();
    this.networkCapture.start();
    this.errorCapture.start();
    this.resourceTimingCapture.start();
    this.routeHistory.start();
    this.sessionTimeline.start();
  }

  stop(): void {
    this.consoleCapture.stop();
    this.networkCapture.stop();
    this.errorCapture.stop();
    this.resourceTimingCapture.stop();
    this.routeHistory.stop();
    this.sessionTimeline.stop();
  }

  clear(): void {
    this.consoleCapture.clear();
    this.networkCapture.clear();
    this.errorCapture.clear();
    this.resourceTimingCapture.clear();
    this.routeHistory.clear();
    this.sessionTimeline.clear();
  }

  snapshot(): TechnicalDiagnosticsPayload {
    return {
      browserMetadata: this.browserMetadata.buildBrowserMetadata(),
      environmentMetadata: this.environmentMetadata.buildEnvironmentMetadata(),
      userMetadata: this.userMetadata.getUserMetadata(),
      consoleLogs: this.consoleCapture.getEntries(),
      networkLogs: this.networkCapture.getEntries(),
      errors: this.errorCapture.getEntries(),
      routeHistory: this.routeHistory.getEntries(),
      sessionTimeline: this.sessionTimeline.getEntries(),
      resourceTimings: this.resourceTimingCapture.getEntries(),
    };
  }
}
